import { Injectable } from '@angular/core';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SqacodeService {
  private rootUrl: string;
  private sqacodeAPIUrl;

  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.sqacodeAPIUrl = ApiConfig.SqacodeApiConfig;
   }
	
	deleteEquipmentTypeLink(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.deleteEquipmentTypeLink}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}
	
	deleteSQACode(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.deleteSQACode}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}
	

	
	deleteSQACodeLink(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.deleteSQACodeLink}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}
	
	getBatchSQA(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getBatchSQA}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}
	
	getEquipmentSQACodes(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getEquipmentSQACodes}`,  sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getWorkTypeSQACodes(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getWorkTypeSQACodes}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getSQACodeEquipmentTypes(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getSQACodeEquipmentTypes}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getServiceReqSqaCodes(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getServiceReqSqaCodes}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	

	getEquipmentTypeSQACodes(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getEquipmentTypeSQACodes}`, sqacodeObj )
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getSQACodeDisplayOrder(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getSQACodeDisplayOrder}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getWebFormSQACodes(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getWebFormSQACodes}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getSQACodes(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.getSQACodes}`,sqacodeObj )
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	createEquipmentTypeLink(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.createEquipmentTypeLink}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	createSQACode(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.createSQACode}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	updateSQACodeLink(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.updateSQACodeLink}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	createSQACodeLink(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.createSQACodeLink}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	updateSQACode(sqacodeObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.sqacodeAPIUrl.updateSQACode}`, sqacodeObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}



}
